import { TreeInstance } from '@headless-tree/core';
import { useContext } from 'react';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';

import { Context } from './context';

export const useTree = (): [
  TreeInstance<InternalTreeItem> | undefined,
  React.Dispatch<
    React.SetStateAction<TreeInstance<InternalTreeItem> | undefined>
  >,
] => {
  const context = useContext(Context);
  return [context.tree, context.setTree];
};
